import React, { useState } from 'react';
import './Support.css';

function Support() {
    // Check for URL parameters to pre-fill form
    const urlParams = new URLSearchParams(window.location.search);
    const prefilledEmail = urlParams.get('email') || '';
    const prefilledCustomerId = urlParams.get('customer_id') || '';

    const [formData, setFormData] = useState({
        email: prefilledEmail,
        customer_id: prefilledCustomerId,
        subject: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null); const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setResult(null);

        try {
            const apiUrl = process.env.REACT_APP_API_URL || '/api';
            const endpoint = apiUrl.endsWith('/api') ? `${apiUrl}/support` : `${apiUrl}/support.php`;
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    from_app: false
                }),
            });

            const data = await response.json();

            if (data.error) {
                setError(data.message || data.error);
            } else {
                setResult(data.message);
                // Clear form on success
                setFormData({
                    email: '',
                    customer_id: '',
                    subject: '',
                    message: ''
                });
            }
        } catch (err) {
            setError('Failed to submit support request. Please try again.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="support-page">
            <div className="support-container">
                <button className="back-button" onClick={() => window.location.href = '/'}>
                    ← Back to Home
                </button>

                <div className="header">
                    <h1>📧 Support</h1>
                    <p className="subtitle">
                        Get help with BatchMark PDF - for licensed customers only
                    </p>
                </div>

                {!result && (
                    <form onSubmit={handleSubmit} className="support-form">
                        <div className="form-group">
                            <label htmlFor="email">Your Email Address *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="you@example.com"
                                required
                            />
                            <small>We'll respond to this email address</small>
                        </div>

                        <div className="form-group">
                            <label htmlFor="customer_id">Customer ID *</label>
                            <input
                                type="text"
                                id="customer_id"
                                name="customer_id"
                                value={formData.customer_id}
                                onChange={handleChange}
                                placeholder="cus_xxxxxxxxxxxxx"
                                required
                            />
                            <small>Found in your purchase confirmation email. Required to verify you're a customer.</small>
                        </div>

                        <div className="form-group">
                            <label htmlFor="subject">Subject *</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                placeholder="Brief description of your issue"
                                required
                                maxLength="100"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Message *</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Please describe your issue in detail..."
                                required
                                rows="8"
                            />
                            <small>{formData.message.length} characters</small>
                        </div>

                        {error && (
                            <div className="error-message">
                                <strong>❌ {error}</strong>
                            </div>
                        )}

                        <button
                            type="submit"
                            className="submit-button"
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Submit Support Request'}
                        </button>
                    </form>
                )}

                {result && (
                    <div className="result-section">
                        <div className="success-icon">✅</div>
                        <h2>Request Submitted!</h2>
                        <p className="success-message">{result}</p>

                        <button
                            className="link-button"
                            onClick={() => {
                                setResult(null);
                                setFormData({
                                    email: '',
                                    customer_id: '',
                                    subject: '',
                                    message: ''
                                });
                            }}
                        >
                            Submit Another Request
                        </button>
                    </div>
                )}

                <div className="help-section">
                    <h3>Before Submitting</h3>
                    <ul>
                        <li><strong>Check the documentation:</strong> Visit <a href="/">our homepage</a> for guides and FAQs</li>
                        <li><strong>Lost your license?</strong> Use the <a href="/retrieve">license retrieval</a> page</li>
                        <li><strong>Customer ID required:</strong> We can only provide support to verified customers</li>
                        <li><strong>Response time:</strong> We typically respond within 24-48 hours</li>
                    </ul>
                </div>

                <div className="info-section">
                    <h3>Other Ways to Get Help</h3>
                    <p><strong>License Issues:</strong> Use our <a href="/retrieve">license retrieval system</a></p>
                    <p><strong>Pre-sales Questions:</strong> Email us at sales@batchmarkpdf.com</p>
                    <p><strong>Feature Requests:</strong> Submit on our <a href="https://github.com/mcdoolz/pdfhighlighter">GitHub</a></p>
                </div>
            </div>
        </div>
    );
}

export default Support;
